<template>
  <div class="bg-card-grey mt-3">
    <div class="cardy-body-noBorder">
      <div>
        <h4 class="color-dark-purple mb-3">ARQUIVOS</h4>
      </div>
      <div v-for="item in archives" :key="item.id">
        <div>
          <div class="icon-flutuant-close-tb">
            <a :href="item.url" target="_blank" :download="item.name">
              <font-awesome-icon
                icon="cloud-download-alt"
                class="color-purple mr-2 pointer"
                title="Baixar arquivo"
              />
            </a>
            <font-awesome-icon
              icon="times"
              class="color-purple pointer"
              title="Deletar arquivo"
              @click="deleteFile(item.id)"
            />
          </div>
          <span>{{ item.name }}</span>
        </div>
        <div>
          <span> Recrutador(a): {{ item.recruiter.name }}</span>
        </div>
        <div>
          <hr />
        </div>
      </div>
      <div>
        <button
          style="width: 100%"
          class="color-white btn-add-items-tb bg-purple"
          @click="openForm()"
        >
          ADICIONAR ARQUIVOS
        </button>
      </div>
    </div>
  </div>

  <!-- 
  <div>
    <Form :candidate="this.candidate"> </Form>
    <div class="mt-2 block_info_white" v-show="this.archives != ''">
      <div class="col-lg-12 col-xs-12">
        <div class="row" v-for="archive in this.archives" :key="archive.id">
          <div class="col-lg-12 col-xs-12 f20">
            <div class="d-flex justify-content-between">
              <div>
                <span>NOME DO ARQUIVO: </span>
                <span class="color-black">{{ archive.name }}</span>
              </div>
              <div
                class="color-primary pointer"
                @click="deleteFile(archive.id)"
              >
                <i class="fas fa-trash-alt"></i>
              </div>
            </div>
            <div>
              <span class="f18"> DESCRIÇÃO: </span>
              <span class="color-black f15" style="text-align: justify">
                {{ archive.description }}
              </span>
            </div>
            <div class="d-flex justify-content-between">
              <a :href="archive.url" target="blank">
                <span class="f12 color-black pointer">VISUALIZAR ARQUIVO</span>
              </a>
              <div class="f12">
                <span>RESPONSÁVEL:</span>
                <span class="color-black">{{ archive.recruiter.name }}</span>
              </div>
            </div>
            <hr />
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-show="this.archives == ''">
      <div class="col-lg-12 col-xs-12 mt-3">
        <div class="card">
          <div class="card-body">
            <h3 class="center color-grey">
              NENHUM ARQUIVO DISPONÍVEL ATÉ O MOMENTO
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import Form from "./Form.vue";
export default {
  props: ["candidate"],
  components: { Form },
  data: () => ({
    archives: "",
    showForm: false,
  }),
  methods: {
    openForm() {
      this.$modal.show(
        Form,
        {
          candidate: this.candidate,
        },
        {
          width: "70%",
          height: "auto",
          scrollable: true,
        }
      );
    },
    getFiles() {
      axios.get(this.makeURL("files")).then((response) => {
        this.archives = response.data.files;
      });
    },
    deleteFile(id) {
      let conf = confirm("Deseja realmente apagar esse arquivo?");
      if (!conf) return;
      axios.delete(this.makeURL(`file/${id}`)).then((response) => {
        this.getFiles();
        response.data.isDeleted == true
          ? this.$toast.success("Arquivo removida com sucesso")
          : this.$toast.error("Você não pode remover esse arquivo");
      });
    },
    makeURL(extra) {
      return `/recruiters/talent_banks/${this.candidate.id}/candidate/` + extra;
    },
  },
  mounted() {
    this.getFiles();
    eventBus.$on("getFiles", () => {
      this.getFiles();
    });
  },
};
</script>